import { branding } from 'app/config';

export const NAME = 'version';
export const LIST_NAME = 'versionList';
export const FORM_NAME = 'versionDiff';
export const DEFAULT_USER_NAME = branding.productName;
